import React from 'react'
import { push } from 'connected-react-router'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Modal, Button } from 'react-bootstrap'
import './style.scss'
import ImageGallery from 'react-image-gallery'
import Api from '../../../utils/api'

class SellersFullInfo extends React.Component {
    constructor (props) {
        super(props);

        this.state = {
            data: [],
            isImageGalleryShow: false,
            apartmentPhotos: [],
            apartmentLayout: []
        };
    }

    componentWillMount () {
        const data = this.props.data;

        const apartmentPhotos = data.photoArray ?
            data.photoArray.split(',').map(item => {
                return { original: 'http://' + Api.getAPIUrl() + '/static/photo/' + data.id + '_' + item + '.png' }
            })
            : [];

        const apartmentLayout = data.layoutArray ?
            { original: 'http://' + Api.getAPIUrl() + '/static/layout/' + data.id + '_' + data.layoutArray.split(',')[0] + '.png' }
            : [];

        this.setState({
            apartmentPhotos,
            apartmentLayout
        });
    }

    onImageGalleryShow (type, index) {
        const state = this.state;
        let array = [];

        if (type === 'photo') {
            array = state.apartmentPhotos;
        }
        else {
            array = [state.apartmentLayout];
        }

        this.setState({
            isImageGalleryShow: true,
            imageGalleryArray: array
        }, () => {
            this.imageGallery.fullScreen();
            this.imageGallery.slideToIndex(index);
        });
    }

    onGalleryScreenChange = (event) => {
        this.imageGallery.getSnapshotBeforeUpdate = (props, state) => {
            if(!state.isFullscreen && this.state.isImageGalleryShow) {
                this.setState({
                    isImageGalleryShow: false
                });
            }
            else if(state.isFullscreen && !this.state.isImageGalleryShow) {
                this.setState({
                    isImageGalleryShow: true
                });
            }

            return null;
        }
    }

    getWallsMaterial = (data) => {
        let wallsMaterial = this.props.general.wallsMaterial.find(item => item.id === data.wallsMaterial)
        if(wallsMaterial) {
            return wallsMaterial.name;
        }
        else {
            return '-';
        }
    }

    getLocation = (data) => {
        let location = this.props.general.location.find(item => item.id === data.location)
        if(location) {
            return location.name;
        }
        else {
            return '-';
        }
    }

    getOwnerShipType = (data) => {
        let ownershipType = this.props.general.ownershipType.find(item => item.id === data.ownershipType)
        if(ownershipType) {
            return ownershipType.name;
        }
        else {
            return '-';
        }
    }

        getDistrict = (data) => {
        const districtValue = data.district;

        if (districtValue === undefined || districtValue === null || districtValue === '') {
            return '-';
        }

        const districtAsNumber = Number(districtValue);
        const district = this.props.general.district.find(item => item.id === districtAsNumber);
        if (district) {
            return district.name;
        }

        if (typeof districtValue === 'string') {
            return districtValue;
        }

        return '-';
    }

    getRepairType = (data) => {
        const repairsValue = data.repairs;
                const repair = this.props.general.repairType.find(item => Number(item.id) === Number(repairsValue));


        if (repair) {
            return repair.name;
        }

        if (typeof repairsValue === 'string' && repairsValue.trim()) {
            return repairsValue;
        }

        return '-';
    }


    getSubType = (data) => {
        let subType = this.props.general.subType[data.type].find(item => item.id === data.subType)
        if(subType) {
            return subType.name;
        }
        else {
            return '-';
        }
    }

    mainParams = (data) => {
        return (
          <div className="block">
              <div className="title">Основные характеристики</div>
              <div className="two-side">
                  <ul>
                      {data.type === 5 ? (<li>Объект:</li>) : ''}
                      {data.type === 3 || data.type === 4 ? (<li>Расположение:</li>) : ''}
                      {data.type === 2 ? (<li>Право собственности:</li>) : ''}
                      {data.type !== 5 ? (<li>{data.type === 2 ? 'Количество комнат в квартире:' : 'Количество комнат:'}</li>) : ''}
                      {data.type === 3 || data.type === 4 ? (<li>Площадь уч.:</li>) : ''}
                      {data.type === 3 ? (<li>Площадь дома:</li>) : (<li>Площадь:</li>)}
                      {data.type === 3 || data.type === 5 ? (<li>Этажность:</li>) : (<li>Этаж:</li>)}
                      <li>Год постройки:</li>
                      <li>Ремонт:</li>
                      {data.type === 2 || data.type === 5 ? (<li>Материлалы стен:</li>) : ''}
                      <li>Стоимость:</li>
                  </ul>
                  <ul>
                      {data.type === 5 ? (<li>{this.getSubType(data)}</li>) : ''}
                      {data.type === 3 || data.type === 4 ? (<li>{this.getLocation(data)}</li>) : ''}
                      {data.type === 2 ? (<li>{this.getOwnerShipType(data)}</li>) : ''}
                      {data.type !== 5 ? (<li>{data.rooms}</li>) : ''}
                      {data.type === 3 || data.type === 4 ? (<li>{data.landSquare} сот.</li>) : ''}
                      <li>{data.square}</li>
                      {data.type === 3 || data.type === 5 ? (<li>{data.floorsCount}</li>) : (<li>{data.floor}</li>)}
                      <li>{data.builtYear}</li>
                                            <li>{this.getRepairType(data)}</li>

                      {data.type === 2 || data.type === 5 ? (<li>{this.getWallsMaterial(data)}</li>) : ''}
                      <li><span style={{fontWeight: 'bold', fontSize: 20}}>{(data.cost * 1000).toLocaleString('ru')} р. </span>
                          ({(data.priceM2 * 1000).toLocaleString('ru')} {data.type === 3 ? 'р/сот' : 'р/м2'})</li>
                  </ul>
              </div>
          </div>
        )
    }

    render = () => {
        const data = this.props.data;
        const { apartmentPhotos, apartmentLayout, imageGalleryArray } = this.state;

        return (
            <>
            { data.id > 0 ?
                <Modal size="lg" className="seller-card" show={true} onHide={this.props.onHide}>
                    <Modal.Header closeButton>
                        <Modal.Title>Объект №{data.id}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div class="object-id">
                            <span class="id">Код {data.id}</span>
                                                        {data.type !== 3 ?
                              (<span className="address">{data.address}</span>) :
                                (<span className="address">{[data.city, `р-н ${this.getDistrict(data)}`, data.street, data.houseNumber].filter(Boolean).join(', ')}</span>)}

                        </div>

                        <div className="info">
                            {this.mainParams(data)}
                            <div className="block">
                                <div className="title">Ответственный специалист</div>
                                <ul>
                                    <li>{data.realtorName}</li>
                                    <li>
                                        <span>Телефон:</span>
                                        <span>{data.realtorPhone}</span>
                                    </li>
                                    <li>
                                        <span>Email:</span>
                                        <span>{data.realtorEmail}</span>
                                    </li>
                                </ul>
                                <div className="realtorLogo" style={{backgroundImage: 'url(http://' + Api.getAPIUrl() + '/static/designLogo/' + data.realtor + '.png)'}}></div>
                            </div>
                        </div>

                        <div className="photo-gallery">
                            {
                                apartmentPhotos.map((item, index) =>
                                    <div key={item} onClick={() => this.onImageGalleryShow('photo', index)} style={{backgroundImage: 'url(' + item.original + ')'}}/>
                                )
                            }
                        </div>

                        <div className="info">
                            <div className="block">
                                <div className="title">Описание</div>
                                <div>{data.info}</div>
                            </div>
                            <div className="block">
                                <div className="title">Планировка</div>
                                {
                                    data.layoutArray &&
                                        <div className="layoutImg" onClick={() => this.onImageGalleryShow('layout', 0)} style={{backgroundImage: 'url(' + apartmentLayout.original + ')'}}/>
                                }
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
                : null
                }
                { this.state.isImageGalleryShow &&
                    <ImageGallery ref={el => this.imageGallery = el} onScreenChange={this.onGalleryScreenChange} showIndex={true} items={imageGalleryArray} />
                }
            </>
        )
    }
}

const mapStateToProps = ({ user, seller, router, general }) => ({
    user,
    general,
    seller,
    location: router.location
})

const mapDispatchToProps = dispatch =>
bindActionCreators(
{
    changePage: (page) => push(page)
},
    dispatch
)

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SellersFullInfo)
